import { createContext, useState } from "react";

export const PlayerContext = createContext();

export const PlayerContextProvider = ({ children }) => {
    const [playerData, setPlayerData] = useState(defaultPlayerData);

    return (
        <PlayerContext.Provider value={{ playerData, setPlayerData }}>
            {children}
        </PlayerContext.Provider>
    );
};

export const defaultPlayerData = {
    name: '',
    pid: '',
    udid: '',
    userKey: '',
    created: '',
    lastLogin: '',
    country: '',
    language: '',
    userState: 0,
    uid: '',
    loginType: 0,
    stateDate: '',
    stateReason: 0,
    playerInfo: {
        userInfo: {
            Nickname: '',
            Pid: '',
            LastStore: 0,
            Avatar: 0,
            Level: 0,
            Exprience: 0, // <- typo experience
            EnergyChargeCount: 0,
            LastLoginDateTime: ''
        },
        walletData: {
            Gold: 0,
            Energy: 0,
            EnergyUpdateDateTime: '',
            Diamond: 0,
            DiamondByPaid: 0,
            Star: 0,
            FreeDraw: 0,
            NextFreeDrawDateTime: '',
            RainbowCapsule: 0,
            MissionPoint: 0,
            PuddingPoint: 0,
            HammerPiece: 0,
        },
    },
};